
// ============================================================================
// UTILITY HELPERS
// ============================================================================

const emptyRow = { label: "", value: "", unit: "" };

export const formatNumber = (value, decimals) => {
    if (value == null) return "-";
    const num = Number(value);
    if (isNaN(num)) return "-";
    const fixed = decimals != null ? num.toFixed(decimals) : String(num);
    const parts = fixed.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return parts.join(".");
};

export const getTankSpecificationsResults = (data) => {
    const tankResults = data?.tankSpecifications || {};

    return [

        { label: "L = OD", value: tankResults.l, unit: "mm" },
        { label: "r = 0,1*OD", value: tankResults.r, unit: "mm" },
        { label: "t", value: tankResults.t, unit: "mm" },
        { label: "OD", value: tankResults.od, unit: "mm" },
        { label: "ID", value: tankResults.id, unit: "mm" },
        { label: "SL", value: tankResults.sl, unit: "mm" },
        { label: "SF", value: tankResults.sf, unit: "mm" },
        { label: "IDD", value: tankResults.idd, unit: "mm" },
        { label: "SSL", value: tankResults.ssl, unit: "mm" },
        { label: "h1", value: tankResults.h1, unit: "mm" },
        { label: "h2", value: tankResults.h2, unit: "mm" },
        { label: "h3", value: tankResults.h3, unit: "mm" },
        emptyRow,
        { label: "vh1", value: tankResults.vh1, unit: "m3" },
        { label: "vh2", value: tankResults.vh2, unit: "m3" },
        { label: "Vhead", value: tankResults.vhead, unit: "m3" },
        emptyRow,
        { label: "Vcylinder", value: tankResults.vcylinder, unit: "m3" },
        emptyRow,
        { label: "Vvessel", value: tankResults.vvessel, unit: "m3" },
        emptyRow,
        { label: "c", value: tankResults.c, unit: "" },
        emptyRow,
        emptyRow,
        { label: "Storage-H", value: tankResults.hStorage ?? tankResults.hstorage, unit: "mm", highlight: true },
        { label: "Storage-VH", value: tankResults.vhStorage, unit: "m3" },
        { label: "Storage-Occupied Volume", value: tankResults.targetStorageOccupiedValue, unit: "%" },
        emptyRow,
        emptyRow,
        { label: "Retention-H", value: tankResults.hretention ?? data.hretention, unit: "mm", highlight: true },
        { label: "Retention-VH", value: tankResults.vhRetention, unit: "m3" },
        { label: "Retention-Occupied Volume", value: tankResults.targetRetentionOccupiedValue, unit: "%" },
        { label: "Volume Útil (NWL 75% - LWL 350mm)", value: tankResults.usefulVolume?.toFixed(1), unit: "m3" }
    ];
};

export const getBudgetInputs = (data, t) => {
    const tankResults = data?.tankSpecifications || {};
    return [
        { label: t("budgetForm.vesselCalc.degassingCapacity"), value: tankResults.degassingCapacity, unit: "t/h", highlight: true },
        { label: t("budgetForm.vesselCalc.diameter"), value: tankResults.diameter, unit: "m", highlight: true },
        { label: t("budgetForm.vesselCalc.bodyLength"), value: tankResults.bodyLength, unit: "m", highlight: true }
    ];
}

export const getTankResults = (data, t) => {
    const tankResults = data?.tankSpecifications || {};
    return [
        { label: t("budgetForm.vesselCalc.normalOperatingLevel"), value: tankResults.normalOperatingLevel, unit: "%", highlight: true },
        { label: t("budgetForm.vesselCalc.retentionTime"), value: tankResults.retentionTime, unit: "h", highlight: true },
        { label: t("budgetForm.vesselCalc.capacity"), value: tankResults.tankCapacity, unit: "m3" },
        { label: t("budgetForm.vesselCalc.emptyNwlCapacity"), value: tankResults.emptyNwlCapacityM3, unit: "m3" },
        { label: t("budgetForm.cylindricalShellCalc.result"), value: tankResults.firstCondition ? t("budgetForm.vesselCalc.resultOk") : t("budgetForm.vesselCalc.resultInvalidLower"), unit: "" },
        emptyRow,
        { label: t("budgetForm.vesselCalc.storageTime"), value: tankResults.storageTime, unit: "h", highlight: true },
        { label: t("budgetForm.vesselCalc.capacityNwlLwl"), value: tankResults.capacityNwlM3, unit: "m3" },
        { label: t("budgetForm.vesselCalc.requiredCapacity"), value: tankResults.requiredCapacityM3, unit: "m3" },
        { label: t("budgetForm.cylindricalShellCalc.result"), value: tankResults.secondCondition ? t("budgetForm.vesselCalc.resultOk") : t("budgetForm.vesselCalc.resultInvalidLower"), unit: "" },
    ];
}

export const getTowerSpecificationsResults = (data) => {
    const towerResponse = data?.towerSpecifications || {};

    const traySpacing = towerResponse.traySpacing;
    const adoptedTraySpacing = towerResponse.adoptedTraySpacing;

    const isTraySpacingUltrapassada =
        traySpacing != null &&
        adoptedTraySpacing != null &&
        traySpacing > adoptedTraySpacing;


    return [
        // Geometry
        { label: "Altura da virola", value: towerResponse.towerHeight?.toFixed(2), unit: "m" },
        { label: "Diâmetro da torre", value: towerResponse.towerDiameter?.toFixed(2), unit: "m" },
        { label: "Nº pulverizadores", value: towerResponse.numberOfSprayers },
        emptyRow,
        // Process conditions
        { label: "Pressão de serviço", value: towerResponse.operatingPressure?.toFixed(2), unit: "bar(a)", highlight: true },
        { label: "Temperatura de serviço", value: towerResponse.serviceTemperature?.toFixed(2), unit: "ºC" },

        { label: "Caudal de água Make-Up", value: towerResponse.makeUpWaterFlowRate?.toFixed(2), unit: "kg/h" },
        { label: "Temp. da água Make-Up", value: towerResponse.makeUpWaterTemperature?.toFixed(2), unit: "ºC" },

        { label: "Caudal Condensados", value: towerResponse.condensateFlowRate?.toFixed(0), unit: "kg/h", highlight: true },
        { label: "Temp. dos condensados", value: towerResponse.minCondensateTemperature?.toFixed(0), unit: "ºC", highlight: true },

        { label: "Pressão do vapor disponível", value: towerResponse.availableSteamPressure?.toFixed(0), unit: "bar(a)", highlight: true },
        { label: "Entalpia do vapor", value: towerResponse.vaporEnthalpy?.toFixed(1), unit: "kJ/kg" },
        { label: "Temp. do vapor", value: towerResponse.steamTemperature?.toFixed(1), unit: "ºC" },

        // Thermal balance
        { label: "Temp. média da água entrada", value: towerResponse.averageIncomingWaterTemperature?.toFixed(1), unit: "ºC" },
        { label: "Temp. média da água na torre", value: towerResponse.coolingTowerInletWaterTemperature?.toFixed(1), unit: "ºC" },

        { label: "Densidade da água à tm", value: towerResponse.waterDensity?.toFixed(1), unit: "kg/m³" },
        { label: "Caudal volúmico de água (médio)", value: towerResponse.averageWaterVolumetricFlow?.toFixed(1), unit: "m³/h" },

        { label: "Dif. de temp. média logarítmica", value: towerResponse.logMeanTempDifference?.toFixed(1), unit: "ºC" },
        { label: "cp água (médio)", value: towerResponse.cpWater?.toFixed(1), unit: "J/(kg·K)" },

        { label: "Potência térmica transferida", value: towerResponse.thermalPower?.toFixed(1), unit: "kW" },
        { label: "Caudal mássico de vapor requerido", value: towerResponse.specificThermalEnergy?.toFixed(1), unit: "kg/h" },
        emptyRow,
        // Tray & jet design
        { label: "Número de tatuleiros", value: towerResponse.numberOfTatuleiros },
        { label: "Diâmetro da furação", value: towerResponse.holeDiameter?.toFixed(2), unit: "mm" },
        { label: "Percentagem de área furada", value: towerResponse.percentOpenArea?.toFixed(1), unit: "%" },
        { label: "Superfície total do tabuleiro", value: towerResponse.totalTraySurface?.toFixed(2), unit: "m²" },
        emptyRow,
        emptyRow,
        { label: "Coef. Global de Transferência", value: towerResponse.globalHeatTransferCoefficient?.toFixed(1), unit: "W/m²·K" },
        emptyRow,
        emptyRow,
        { label: "Superfície de transferência (mínima)", value: towerResponse.minimumHeatTransferSurface?.toFixed(1), unit: "m²" },
        { label: "Número de furos por tabuleiro", value: towerResponse.numberOfHolesPerTray?.toFixed(0) },
        { label: "Perímetro total dos jactos / tabuleiro", value: towerResponse.totalJetPerimeterPerTray?.toFixed(1), unit: "m" },
        { label: "Altura min. necessária dos jactos", value: towerResponse.minimumRequiredJetHeight?.toFixed(1), unit: "mm" },
        { label: "Distância min. entre tabuleiros", value: towerResponse.minimumTraySpacing?.toFixed(1), unit: "mm" },
        emptyRow,
        { label: "Margem de sobredimensionamento", value: towerResponse.overdimensioningMargin?.toFixed(1), unit: "%" },
        { label: "Distância entre tabuleiros", value: towerResponse.traySpacing?.toFixed(1), unit: "mm" },
        { label: "Distância entre tabuleiros adoptada", value: towerResponse.adoptedTraySpacing?.toFixed(1), unit: "mm", highlight: true },
        ...(isTraySpacingUltrapassada
            ? [emptyRow,
                {
                    label: "Aviso",
                    value: "Distância entre tabuleiros ultrapassada",
                    warning: true,
                },
                emptyRow]
            : []),
        { label: "Altura min. da zona de condensação", value: towerResponse.totalTrayStackHeight?.toFixed(1), unit: "mm" },
        { label: "Secção total dos furos / tabuleiro", value: towerResponse.totalHoleAreaPerTray?.toFixed(2), unit: "m²" },
        { label: "Coeficiente de Vazão", value: towerResponse.flowCoefficient?.toFixed(2) },
        { label: "Velocidade dos jactos", value: towerResponse.jetVelocity?.toFixed(4), unit: "m/s" },
        { label: "Altura min. da água nos tabuleiros", value: towerResponse.minWaterHeight?.toFixed(4), unit: "mm" }
    ];
};

export const getWarmUpCalculations = (data) => {
    const warmUp = data?.warmUp || {};

    return [
        { label: "Caudal", value: warmUp.massFlowRate?.toFixed(1), unit: "kg/h" },
        emptyRow,
        { label: "Pressão do desgasificador", value: warmUp.deaeratorPressure?.toFixed(2), unit: "bar(g)" },
        { label: "Temp. líquido saturado", value: warmUp.saturatedLiquidTemperature?.toFixed(2), unit: "ºC" },
        { label: "Entalpia líquido saturado", value: warmUp.saturatedLiquidEnthalpy?.toFixed(2), unit: "kJ/kg" },
        emptyRow,
        { label: "Pressão água make-up", value: warmUp.makeupWaterPressure?.toFixed(0), unit: "bar(g)", highlight: true },
        { label: "Temp. da água", value: warmUp.makeupWaterTemperature?.toFixed(0), unit: "ºC", highlight: true },
        { label: "Entalpia da água", value: warmUp.makeupWaterEnthalpy?.toFixed(2), unit: "kJ/kg" },
        emptyRow,
        { label: "Potência necessária", value: warmUp.requiredHeatingPower?.toFixed(2), unit: "kW" },
        emptyRow,
        { label: "Pressão do vapor", value: warmUp.steamPressure?.toFixed(2), unit: "bar(g)" },
        { label: "Temp. vapor", value: warmUp.steamTemperature?.toFixed(2), unit: "ºC" },
        { label: "Entalpia do vapor", value: warmUp.steamEnthalpy?.toFixed(2), unit: "kJ/kg" },
        emptyRow,
        { label: "Caudal de vapor", value: warmUp.steamMassFlowRate?.toFixed(2), unit: "kg/h" },
        emptyRow,
        { label: "Tempo de aquecimento", value: warmUp.heatingTime?.toFixed(0), unit: "h", highlight: true },
        emptyRow,
        { label: "Caudal de vapor", value: warmUp.warmupSteamMassFlowRate?.toFixed(2), unit: "kg/h" },
        emptyRow,
        { label: `Capacidade do Injetor ${warmUp.injectorType}`, value: warmUp.injectorCapacity?.toFixed(1), unit: "kg/h" },
        emptyRow,
        { label: `Nº injetores ${warmUp.injectorType}`, value: warmUp.numberOfInjectors?.toFixed(0), unit: "" },
        emptyRow,
        { label: `  ${warmUp.injectorSpacingDiagram}`, value: "", unit: "" },
    ];
};



export const getCylindricalShellSection1Results = (data, isTower, t) => {

    const d = isTower ? data?.towerCylindricalShellSheetResult?.cylindricalShellSection1 || data : data?.tankCylindricalShellSheetResult?.cylindricalShellSection1 || data;

    let rowsMaterial = [];

    if (d.minimumTensileStrength === null && d.minimumProofStress === null) {
        rowsMaterial = [
            { label: "Resistência mín. à Tracção (RmT)", value: d.minimumTensileStrengthStainlessStell, unit: "MPa", highlight: true },
            { label: "Tensão mín. Limite Elasticidade (Rp1,0T)", value: d.minimumProofStressStainlessStell, unit: "MPa", highlight: true }
        ]
    } else {
        rowsMaterial = [
            { label: t("budgetForm.cylindricalShellCalc.minTensileStrength"), value: d.minimumTensileStrength, unit: "MPa", highlight: true },
            { label: t("budgetForm.cylindricalShellCalc.minProofStress"), value: d.minimumProofStress, unit: "MPa", highlight: true }
        ]
    }

    return [
        { label: t("budgetForm.cylindricalShellCalc.shellMaterial"), value: d.materialName, unit: "" },
        { label: t("budgetForm.cylindricalShellCalc.jointCoefficient"), value: d.z, unit: "" },
        { label: t("budgetForm.cylindricalShellCalc.calcTemperature"), value: d.designTemperature, unit: "ºC", highlight: true },
        rowsMaterial[0],
        rowsMaterial[1],
        { label: t("budgetForm.cylindricalShellCalc.nominalDesignStress"), value: d.designNominalStress?.toFixed(2), unit: "MPa", highlight: false },
        emptyRow,
        { label: t("budgetForm.cylindricalShellCalc.internalCalcPressure"), value: d.designInternalPressure, unit: "MPa" },
        { label: t("budgetForm.cylindricalShellCalc.shellOuterDiameter"), value: d.shellOuterDiameter, unit: "mm", highlight: true },
        { label: t("budgetForm.cylindricalShellCalc.minRequiredThickness"), value: d.minimumRequiredThickness, unit: "mm" },
        emptyRow,
        { label: t("budgetForm.cylindricalShellCalc.nominalShellThickness"), value: d.nominalShellThickness, unit: "mm", highlight: true },
        { label: t("budgetForm.cylindricalShellCalc.negativeTolerance"), value: `${d.nominalShellTolerance}`, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.corrosionAllowance"), value: `${d.corrosionAllowance}`, unit: "mm", highlight: true },
        { label: t("budgetForm.cylindricalShellCalc.extraThickness"), value: d.extraThickness, unit: "mm" },
        {
            label: t("budgetForm.cylindricalShellCalc.result"),
            value: d.extraThicknessUnSufficient === false ? t("budgetForm.cylindricalShellCalc.resultCorrect") : t("budgetForm.cylindricalShellCalc.resultInsufficient"),
            highlight2: true
        },
    ];
};


export const getCylindricalShellSection2Results = (data, isTower, t) => {
    const d = isTower ? data?.towerCylindricalShellSheetResult?.cylindricalShellSection2 || {} : data?.tankCylindricalShellSheetResult?.cylindricalShellSection2 || {};

    return [
        { label: t("budgetForm.cylindricalShellCalc.nozzleMaterial"), value: "EN 10216 - P235GH", unit: "", highlight: true },
        { label: t("budgetForm.cylindricalShellCalc.nozzleMinTensileStrength"), value: d.rm20, unit: "MPa", highlight: true },
        { label: t("budgetForm.cylindricalShellCalc.nozzleMinProofStress"), value: d.rp02T, unit: "MPa", highlight: true },
        { label: t("budgetForm.cylindricalShellCalc.nominalDesignStress"), value: d.minDesignNominalStress.toFixed(2), unit: "MPa", },
        emptyRow,
        { label: t("budgetForm.cylindricalShellCalc.nozzleOuterDiameter"), value: d.externalNozzleDiameter, unit: "mm", highlight: true },
        { label: t("budgetForm.cylindricalShellCalc.nozzleMinRequiredThickness"), value: d.minRequiredThickness, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.nozzleNominalThickness"), value: d.nominalNozzleThickness, unit: "mm", highlight: true },
        emptyRow,
        { label: t("budgetForm.cylindricalShellCalc.nozzleTd"), value: d.td, unit: " " },
        { label: t("budgetForm.cylindricalShellCalc.nozzleNegativeTolerance"), value: d.negativeTolerance, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.extraThickness"), value: d.extraThickness, unit: "mm" },
        {
            label: t("budgetForm.cylindricalShellCalc.result"),
            value: d.extraThicknessUnSufficient === false ? t("budgetForm.cylindricalShellCalc.resultCorrect") : t("budgetForm.cylindricalShellCalc.resultInsufficient"),
            highlight2: true
        },
    ];
};


export const getCylindricalShellSection3Results = (data, isTower, t) => {
    const d = isTower ? data?.towerCylindricalShellSheetResult?.cylindricalShellSection3 || {} : data?.tankCylindricalShellSheetResult?.cylindricalShellSection3 || {};

    return [
        { label: t("budgetForm.cylindricalShellCalc.shellOuterDiameterOpening"), value: d.externalShellDiameter, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.nominalShellThickness"), value: d.nominalShellThickness, unit: "mm", highlight: true },
        { label: t("budgetForm.cylindricalShellCalc.negativeTolerance"), value: d.nominalShellTolerance, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.shellInnerDiameter"), value: d.internalShellDiameter, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.shellCorrosionAllowance"), value: d.shellCorrosionAllowance, unit: "mm", highlight: true },
        { label: t("budgetForm.cylindricalShellCalc.shellInnerDiameterCorroded"), value: d.corrodedInternalShellDiameter, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.shellInnerRadiusCorroded"), value: d.corrodedInternalShellRadius, unit: "mm" },

        emptyRow,

        { label: t("budgetForm.cylindricalShellCalc.nozzlePipeOuterDiameter"), value: d.externalNozzleDiameter, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.nozzlePipeNominalThickness"), value: d.nominalNozzleThickness, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.pipeNegativeTolerance"), value: d.nozzleNegativeTolerance, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.pipeCorrosionAllowance"), value: d.nozzleCorrosionAllowance, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.pipeMinFabricationThickness"), value: d.minManufacturableNozzleThickness, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.pipeAnalysisThickness"), value: d.analysisNozzleThickness, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.nozzlePipeEffectiveThickness"), value: d.effectiveNozzleThickness, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.pipeInnerDiameterCorroded"), value: d.corrodedInternalNozzleDiameter, unit: "mm" },
        emptyRow,
        {
            label: t("budgetForm.cylindricalShellCalc.openingRatio"),
            value: d.openingValue?.toFixed(3),
            unit: ""
        },
        emptyRow,
        {
            label: `${t("budgetForm.cylindricalShellCalc.result")} (${d.openingValue} < 1.0) `,
            value: d.ruleH98WithError === false ? t("budgetForm.cylindricalShellCalc.resultCorrect") : t("budgetForm.cylindricalShellCalc.resultError"),
            unit: "",
            highlight2: true,
            error: d.ruleH116WithError === true
        },
        emptyRow,
        { label: t("budgetForm.cylindricalShellCalc.negativeTolerance"), value: d.nominalShellTolerance, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.shellMinFabricationThickness"), value: d.minManufacturableShellThickness, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.shellAnalysisThickness"), value: d.analysisShellThickness, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.openingToWeldDistance"), value: d.distanceFromOpeningToShellWeld, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.weldCenterlineToOpeningDistance"), value: d.centerlineDistanceToOpening, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.reinforcementCalcLength"), value: d.ln, unit: "mm" },
        {
            label: `${t("budgetForm.cylindricalShellCalc.minDistanceCheck")} (${d.centerlineDistanceToOpening} > ${d.ln})`,
            value: d.ruleH116WithError === false ? t("budgetForm.cylindricalShellCalc.resultCorrect") : t("budgetForm.cylindricalShellCalc.resultInvalid"),
            highlight2: true,
            error: d.ruleH116WithError === true
        },
        emptyRow,
        { label: t("budgetForm.cylindricalShellCalc.minRequiredThickness"), value: d.minRequiredThickness, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.shellAssumedThickness"), value: d.analysisShellThickness, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.shellMaxLengthForReinforcement"), value: d.maxShellLength, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.shellInnerRadiusCorroded"), value: d.corrodedInternalShellRadius, unit: "mm" },
        emptyRow,
        {
            label: `${t("budgetForm.cylindricalShellCalc.minDistanceCheck")} (${d.distanceFromOpeningToShellWeld} > ${d.minC129F129})`,
            value: d.ruleH132WithError === false ? t("budgetForm.cylindricalShellCalc.resultCorrect") : t("budgetForm.cylindricalShellCalc.resultInvalid"),
            highlight2: true,
            error: d.ruleH132WithError === true
        },
        emptyRow,
        { label: t("budgetForm.cylindricalShellCalc.crossSectionAreasUnderStress"), value: "", unit: "" },

        { label: t("budgetForm.cylindricalShellCalc.filletWeldArea"), value: d.filletWeldArea?.toFixed(1), unit: "mm²" },
        { label: t("budgetForm.cylindricalShellCalc.nozzleLengthOutsideShell"), value: d.nozzleProjectionLength?.toFixed(1), unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.nozzleLengthInsideShellCorroded"), value: d.corrodedNozzleInsertionLength?.toFixed(1), unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.maxNozzleLengthOutsideShell"), value: d.maxTubeProjection?.toFixed(1), unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.effectiveNozzleLengthOutsideShell"), value: d.effectiveTubeProjectionLength?.toFixed(1), unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.effectiveNozzleLengthInsideShell"), value: d.effectiveNozzleInsertionLength?.toFixed(1), unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.effectiveShellLengthForReinforcement"), value: d.effectiveShellLengthForReinforcement?.toFixed(1), unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.shellCrossSectionAreaEffective"), value: d.effectiveShellCrossSectionArea?.toFixed(1), unit: "mm²" },
        { label: t("budgetForm.cylindricalShellCalc.nozzleCrossSectionAreaEffective"), value: d.effectiveTubeCrossSectionArea?.toFixed(1), unit: "mm²" },
        { label: t("budgetForm.cylindricalShellCalc.pressurizedNozzleArea"), value: d.pressurizedTubeArea?.toFixed(2), unit: "mm²" },

        { label: "...", value: "", unit: "" },

        { label: t("budgetForm.cylindricalShellCalc.reinforcementPlateWidth"), value: d.reinforcementPlateWidth?.toFixed(1), unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.effectiveReinforcementPlateWidth"), value: d.effectiveReinforcementPlateWidth?.toFixed(1), unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.nominalReinforcementPlateThickness"), value: d.nominalReinforcementPlateThickness?.toFixed(1), unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.minFabricationReinforcementPlateThickness"), value: d.minimumRolledReinforcementPlateThickness?.toFixed(2), unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.effectiveReinforcementPlateThickness"), value: d.effectiveReinforcementPlateThickness?.toFixed(2), unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.effectiveReinforcementPlateArea"), value: d.effectiveReinforcementPlateArea?.toFixed(1), unit: "mm²" },

        { label: "...", value: "", unit: "" },

        { label: t("budgetForm.cylindricalShellCalc.halfNozzlePipeOuterDiameter"), value: d.halfNozzleOuterDiameter?.toFixed(1), unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.pressurizedShellArea"), value: d.pressurizedShellArea?.toFixed(1), unit: "mm²" },
        { label: t("budgetForm.cylindricalShellCalc.meanShellRadius"), value: d.rms?.toFixed(1), unit: "mm" },
        { label: "sin", value: d.sin?.toFixed(5), unit: "" },
        { label: t("budgetForm.cylindricalShellCalc.pressurizedShellArea"), value: d.pressurizedShellAreaAps?.toFixed(2), unit: "mm²" },
        { label: t("budgetForm.cylindricalShellCalc.maxPressurizedShellArea"), value: d.maxPressurizedShellArea?.toFixed(1), unit: "mm²" },

        { label: "...", value: "", unit: "" },

        { label: t("budgetForm.cylindricalShellCalc.internalCalcPressureMawp"), value: d.mawp?.toFixed(3), unit: "MPa" },
        { label: t("budgetForm.cylindricalShellCalc.shellNominalDesignStress"), value: d.minDesignNominalStress?.toFixed(2), unit: "MPa" },
        { label: t("budgetForm.cylindricalShellCalc.nozzleNominalDesignStress"), value: d.minDesignNominalStressTube?.toFixed(2), unit: "MPa" },
        { label: t("budgetForm.cylindricalShellCalc.reinforcementPlateNominalDesignStress"), value: d.optionalTubeStress?.toFixed(2), unit: "MPa" },
        { label: "fob", value: d.fob?.toFixed(2), unit: "MPa" },
        { label: "fop", value: d.fop?.toFixed(2), unit: "MPa" },
        { label: "D222", value: d.d222?.toFixed(2), unit: "" },

        emptyRow,
        { label: "...", value: "", unit: "" },
        {
            label: `${t("budgetForm.cylindricalShellCalc.isolatedOpeningReinforcement")} [9.5-7] (${d.d227?.toFixed(2)} / ${d.f227?.toFixed(2)})`,
            value: d.h228.toFixed(3),
            unit: "%"
        },
        emptyRow,
        {
            label: t("budgetForm.cylindricalShellCalc.result"),
            value: d.ruleH227WithError === false ? t("budgetForm.cylindricalShellCalc.resultCorrect") : t("budgetForm.cylindricalShellCalc.resultInvalid"),
            highlight2: true,
            error: d.ruleH227WithError === true
        },
        emptyRow,
        {
            label: `${t("budgetForm.cylindricalShellCalc.isolatedOpeningReinforcement")} [9.5-11] (${d.d243 === null && d.f243 === null ? " " : d.d243 > d.f243})`,
            value: "",
            highlight2: true
        },
        {
            label: t("budgetForm.cylindricalShellCalc.result"),
            value: d.ruleH243WithError === false ? t("budgetForm.cylindricalShellCalc.resultCorrect") : t("budgetForm.cylindricalShellCalc.resultInvalid"),
            highlight2: true,
            error: d.ruleH243WithError === true
        },
    ];
};


export const getDishedHeadSection1Results = (data, isTower, t) => {
    const d = isTower ? data?.towerDishedHeadSheetResult?.dishedHeadSection1Result || {} : data?.tankDishedHeadSheetResult?.dishedHeadSection1Result || {};

    let rowsMaterial = [];

    if (d.rm20 === null && d.rp02T === null) {
        rowsMaterial = [
            { label: "Resistência mín. à Tracção (RmT)", value: d.rmt, unit: "MPa", highlight: true },
            { label: "Tensão mín. Limite Elasticidade (Rp1,0T)", value: d.rp1T, unit: "MPa", highlight: true }
        ]
    } else {
        rowsMaterial = [
            { label: t("budgetForm.cylindricalShellCalc.minTensileStrength"), value: d.rm20, unit: "MPa", highlight: true },
            { label: t("budgetForm.dishedHeadCalc.minProofStress"), value: d.rp02T, unit: "MPa", highlight: true }
        ]
    }

    return [
        { label: t("budgetForm.dishedHeadCalc.materialName"), value: d.materialName, unit: "", highlight: true },
        { label: t("budgetForm.cylindricalShellCalc.calcTemperature"), value: d.mawt, unit: "°C" },
        rowsMaterial[0],
        rowsMaterial[1],
        { label: t("budgetForm.dishedHeadCalc.nominalDesignStress"), value: d.minDesignNominalStress?.toFixed(3), unit: "MPa" },
        { label: t("budgetForm.dishedHeadCalc.internalCalcPressure"), value: d.mawp, unit: "MPa" },
        { label: t("budgetForm.dishedHeadCalc.outerDiameter"), value: d.diameterInMM, unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.nominalThickness"), value: d.candidateDishedHeadThickness, unit: "mm", highlight: true },
        { label: t("budgetForm.dishedHeadCalc.innerDiameter"), value: d.innerDishedHeadDiameter, unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.corrosionAllowance"), value: d.corrosionAllowance, unit: "mm", highlight: true },
        { label: t("budgetForm.dishedHeadCalc.innerDiameterCorroded"), value: d.corrodedInnerDishedHeadDiameter, unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.innerSphericalRadius"), value: d.diameterF30, unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.innerSphericalRadiusCorroded"), value: d.corrodedInnerSphericalRadius, unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.innerTorusRadius"), value: d.innerTorusRadius, unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.innerTorusRadiusCorroded"), value: d.corrodedInnerTorusRadius, unit: "mm" },
        { label: "Fator D38", value: d.d38?.toFixed(3) },
        { label: "R/DI (F36 / F28)", value: d.r_DI?.toFixed(3) },
        { label: t("budgetForm.dishedHeadCalc.bucklingDesignStress"), value: d.f14?.toFixed(3), unit: "MPa" },
        { label: t("budgetForm.dishedHeadCalc.minThicknessCentralPart"), value: d.minDishedHeadThickness?.toFixed(3), unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.minTorusThicknessYielding"), value: d.minTorusThickness?.toFixed(3), unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.minTorusThicknessBuckling"), value: d.minTorusThicknessPlasticBuckling?.toFixed(3), unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.governingRequiredThickness"), value: d.e?.toFixed(3), unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.negativeToleranceNominal"), value: d.toleranceMinusNominalDishedHeadThickness, unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.nominalThickness"), value: d.candidateDishedHeadThickness, unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.extraThicknessToNominal"), value: d.extraThickness?.toFixed(3), unit: "mm" },
        { label: `${t("budgetForm.cylindricalShellCalc.result")} H66`, value: d.ruleH66Violated ? t("budgetForm.cylindricalShellCalc.resultInvalid") : t("budgetForm.cylindricalShellCalc.resultCorrect"), highlight2: true, error: d.ruleH243WithError === true },
        { label: "...", value: "", unit: "" },
        { label: t("budgetForm.dishedHeadCalc.assumedMinRequiredThickness"), value: d.f70?.toFixed(2), unit: "mm" },
        { label: "...", value: "", unit: "" },
        { label: t("budgetForm.dishedHeadCalc.assumedMinThickness"), value: d.f70?.toFixed(2), unit: "mm", highlight: true },
        { label: t("budgetForm.dishedHeadCalc.factorY"), value: d.f73?.toFixed(3) },
        { label: t("budgetForm.dishedHeadCalc.factorZ"), value: d.f75?.toFixed(2) },
        { label: t("budgetForm.dishedHeadCalc.factorX"), value: d.f77?.toFixed(2) },
        { label: t("budgetForm.dishedHeadCalc.factorN"), value: d.f79?.toFixed(2) },
        { label: t("budgetForm.dishedHeadCalc.beta006"), value: d.f83?.toFixed(2) },
        { label: t("budgetForm.dishedHeadCalc.beta01"), value: d.f87?.toFixed(2) },
        { label: t("budgetForm.dishedHeadCalc.beta02"), value: d.f95?.toFixed(2) },
        { label: t("budgetForm.dishedHeadCalc.betaInterpolated"), value: d.f99?.toFixed(2) },
        { label: t("budgetForm.dishedHeadCalc.betaFinal"), value: d.f101?.toFixed(2), highlight: true }
    ];
};


export const getDishedHeadSection2Results = (data, isTower, t) => {
    const d = isTower ? data?.towerDishedHeadSheetResult?.dishedHeadSection2Result || {} : data?.tankDishedHeadSheetResult?.dishedHeadSection2Result || {};


    return [
        { label: t("budgetForm.cylindricalShellCalc.nozzleMaterial"), value: "EN 10216 - P235GH", highlight: true },
        { label: t("budgetForm.cylindricalShellCalc.minTensileStrength"), value: d.rm20, unit: "MPa" },
        { label: t("budgetForm.dishedHeadCalc.minProofStress"), value: d.rp02T, unit: "MPa" },
        { label: t("budgetForm.cylindricalShellCalc.nominalDesignStress"), value: d.minDesignNominalStress.toFixed(2), unit: "MPa", highlight: true },
        { label: t("budgetForm.cylindricalShellCalc.nozzleOuterDiameter"), value: d.de, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.nozzleMinRequiredThickness"), value: d.minNozzleThickness?.toFixed(2), unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.nozzleNominalThickness"), value: d.nominalNozzleThickness, unit: "mm", highlight: true },
        { label: t("budgetForm.cylindricalShellCalc.nozzleTd"), value: d.td?.toFixed(3) },
        { label: t("budgetForm.cylindricalShellCalc.nozzleNegativeTolerance"), value: d.negativeTolerance, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.extraThickness"), value: d.extraThickness?.toFixed(2), unit: "mm" },
        {
            label: t("budgetForm.dishedHeadCalc.extraThicknessCheck"),
            value: d.extraThicknessUnSufficient ? t("budgetForm.cylindricalShellCalc.resultInsufficient") : t("budgetForm.cylindricalShellCalc.resultCorrect"),
            highlight2: true,
            error: d.extraThicknessUnSufficient
        },
    ];
};


export const getDishedHeadSection3Results = (data, isTower, t) => {
    const d = isTower ? data?.towerDishedHeadSheetResult?.dishedHeadSection3Result || {} : data?.tankDishedHeadSheetResult?.dishedHeadSection3Result || {};

    return [
        { label: t("budgetForm.dishedHeadCalc.outerDiameterOpening"), value: d.diameterInMM, unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.nominalThickness"), value: d.candidateDishedHeadThickness, unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.corrosionOrErosionAllowance"), value: d.corrosionAllowance, unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.innerSphericalCrownRadiusCorroded"), value: d.corrodedInnerSphericalRadius, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.nozzlePipeOuterDiameter"), value: d.de, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.nozzlePipeNominalThickness"), value: d.nominalNozzleThickness, unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.nozzlePipeInnerDiameter"), value: d.innerNozzleDiameter, unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.pipeNegativeTolerance"), value: d.negativeTolerance, unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.negativeToleranceNominal"), value: d.toleranceMinusNominalDishedHeadThickness, unit: "mm" },

        {
            label: "dib / (2 * ris) ≤ 0,5",
            value: d.d155?.toFixed(3),
            unit: `<= ${d.f155}`,
            highlight2: true,
            error: d.ruleH155Violated
        },
        {
            label: "dib / De ≤ 0,6",
            value: d.d160?.toFixed(3),
            unit: `<= ${d.f160}`,
            highlight2: true,
            error: d.ruleH160Violated
        },
        emptyRow,
        {
            label: t("budgetForm.cylindricalShellCalc.result"),
            value: d.ruleH160Violated || d.ruleH155Violated ? t("budgetForm.cylindricalShellCalc.resultInvalid") : t("budgetForm.cylindricalShellCalc.resultCorrect"),
            highlight2: true,
            error: d.ruleH160Violated || d.ruleH155Violated
        },
        emptyRow,
        { label: t("budgetForm.cylindricalShellCalc.nozzlePipeEffectiveThickness"), value: d.effectiveNozzleThickness?.toFixed(2), unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.minFabricationThickness"), value: d.minimumDishedHeadThickness?.toFixed(2), unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.analysisThickness"), value: d.analysisDishedHeadThickness?.toFixed(2), unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.ebRatio"), value: d.eb?.toFixed(3), unit: "" },
        { label: t("budgetForm.dishedHeadCalc.maxValueFigure"), value: d.figure194, unit: "" },
        { label: t("budgetForm.dishedHeadCalc.minRequiredThicknessSphericalShell"), value: d.minimumSphericalShellThickness, unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.maxShellLengthContributing"), value: d.maxShellLength?.toFixed(2), unit: "mm" },
        { label: "C185", value: d.c185?.toFixed(2), unit: "mm" },
        { label: "F185", value: d.f185?.toFixed(2), unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.c189GreaterOf"), value: d.c189?.toFixed(2), unit: "mm" },
        { label: "...", value: "", unit: "" },
        {
            label: `${t("budgetForm.dishedHeadCalc.sufficientDistanceCheck")} (${d.d195} > ${d.f199?.toFixed(2)})`,
            value: d.ruleH195Violated ? t("budgetForm.cylindricalShellCalc.resultInvalid") : t("budgetForm.cylindricalShellCalc.resultCorrect"),
            highlight2: true,
            error: d.ruleH195Violated
        },
        { label: "...", value: "", unit: "" },
        { label: t("budgetForm.cylindricalShellCalc.crossSectionAreasUnderStress"), value: "", unit: "" },

        { label: t("budgetForm.cylindricalShellCalc.filletWeldArea"), value: d.cornerWeldArea?.toFixed(0), unit: "mm²" },
        { label: t("budgetForm.cylindricalShellCalc.effectiveShellLengthForReinforcement"), value: d.effectiveShellLength?.toFixed(1), unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.shellCrossSectionAreaEffective"), value: d.effectiveShellArea?.toFixed(1), unit: "mm²" },

        { label: "...", value: "", unit: "" },

        { label: t("budgetForm.cylindricalShellCalc.reinforcementPlateWidth"), value: d.reinforcementPlateWidth?.toFixed(1), unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.effectiveShellLengthForReinforcementLp"), value: d.lp?.toFixed(1), unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.nominalReinforcementPlateThickness"), value: d.enp?.toFixed(1), unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.minFabricationReinforcementPlateThickness"), value: d.minRollingThickness?.toFixed(2), unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.effectiveReinforcementPlateThickness"), value: d.effectiveReinforcementThickness?.toFixed(2), unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.reinforcementPlateAreaEffective"), value: d.reinforcementPlateArea?.toFixed(1), unit: "mm²" },

        { label: "...", value: "", unit: "" },

        { label: t("budgetForm.cylindricalShellCalc.nozzleLengthOutsideShell"), value: d.tubeLengthOutsideShell?.toFixed(1), unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.maxNozzleLengthOutsideShell"), value: d.effectiveTubeLength?.toFixed(1), unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.nozzleLengthInsideShellCorroded"), value: d.f235?.toFixed(1), unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.effectiveNozzleLengthInsideShell"), value: d.effectiveTubeLengthInsideShell?.toFixed(1), unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.effectiveNozzleLengthOutsideShell"), value: d.effectiveTubeLengthOutsideShell?.toFixed(1), unit: "mm" },
        { label: t("budgetForm.cylindricalShellCalc.nozzleCrossSectionAreaEffective"), value: d.f245?.toFixed(0), unit: "mm²" },

        { label: "...", value: "", unit: "" },

        { label: t("budgetForm.dishedHeadCalc.meanSphericalShellRadius"), value: d.rms?.toFixed(1), unit: "mm" },
        { label: "sin delta", value: d.sinO?.toFixed(5), unit: "" },
        { label: t("budgetForm.dishedHeadCalc.nozzleInclinationAngle"), value: d.f255?.toFixed(2), unit: "º" },
        { label: t("budgetForm.cylindricalShellCalc.pipeInnerDiameterCorroded"), value: d.corrodedInnerNozzleDiameter?.toFixed(1), unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.apqArea"), value: d.apq?.toFixed(1), unit: "mm²" },
        { label: t("budgetForm.dishedHeadCalc.f263Half"), value: d.f263?.toFixed(1), unit: "mm" },
        { label: t("budgetForm.dishedHeadCalc.equivalentShellAreaReinforcement"), value: d.f267?.toFixed(2), unit: "mm²" },
        { label: t("budgetForm.dishedHeadCalc.areaCrossSectionNozzleReinforcement"), value: d.tubeReinforcementArea?.toFixed(2), unit: "mm²" },

        { label: "...", value: "", unit: "" },
        { label: t("budgetForm.cylindricalShellCalc.internalCalcPressureMawp"), value: d.mawp?.toFixed(3), unit: "MPa" },
        { label: t("budgetForm.cylindricalShellCalc.shellNominalDesignStress"), value: d.minDesignNominalStressSection1?.toFixed(2), unit: "MPa" },
        { label: t("budgetForm.cylindricalShellCalc.nozzleNominalDesignStress"), value: d.minDesignNominalStressSection2?.toFixed(2), unit: "MPa" },
        { label: t("budgetForm.dishedHeadCalc.fobMinValue"), value: d.fob?.toFixed(2), unit: "MPa" },
        { label: "F287", value: d.f287?.toFixed(2), unit: "MPa" },

        { label: "...", value: "", unit: "" },
        {
            label: `${t("budgetForm.dishedHeadCalc.openingsInDishedEndsCheck")} [9.4.5.3] (${d.d298?.toFixed(2)} > ${d.f298?.toFixed(2)})`,
            value: d.ruleH298Violated ? t("budgetForm.cylindricalShellCalc.resultInvalid") : t("budgetForm.cylindricalShellCalc.resultCorrect"),
            highlight2: true,
            error: d.ruleH298Violated
        },
        {
            label: t("budgetForm.dishedHeadCalc.resultPercent"),
            value: d.h298?.toFixed(2),
            unit: "%",
            error: d.ruleH298Violated
        }
    ];

};


export const getVacuumBreakResults = (data) => {
    const d = data;

    const formatValue = (value, decimals = 3) => formatNumber(value, Math.min(decimals, 3));

    const vs = d?.valveSelection;

    return [
        { label: "1. Determinação do calor de evaporação", title: true },
        emptyRow,
        { label: "Massa de vapor de desgasificação (m1)", value: formatValue(d.m1), unit: "kg", highlight: true },
        { label: "Calor de evaporação à pressão de vácuo (r)", value: formatValue(d.r), unit: "kJ/kg" },
        { label: "Calor de evaporação (R)", value: formatValue(d.bigR), unit: "kW" },
        emptyRow,
        emptyRow,
        { label: "2. Calor absorvido pela água de make-up", title: true },
        { label: "Entalpia da água à temperatura de saturação (hmax)", value: formatValue(d.hmax), unit: "kJ/kg" },
        { label: "Entalpia da água fria de make-up (hE)", value: formatValue(d.he), unit: "kJ/kg" },
        { label: "Q = hmax-hE", value: formatValue(d.q, 3), unit: "kJ/kg" },
        emptyRow,
        emptyRow,
        { label: "3. Massa de água necessária para condensar o vapor de aquecimento", title: true },
        { label: "R/Q (m2)", value: formatValue(d.m2, 3), unit: "kg" },
        { label: "t", value: formatValue(d.t, 3), unit: "h" },
        { label: "4. Determinação do caudal de ar necessário para impedir a formação de vácuo", title: true },
        { label: "Var", value: formatValue(d.v1, 3), unit: "m3/h" },
        { label: "5. Determinação do diâmetro nominal da válvula de quebra vácuo", title: true },
        emptyRow,
        { label: "par", value: formatValue(d.par, 3), unit: "kg/m3" },
        { label: "Vw", value: formatValue(d.vw, 3), unit: "m3/h" },
        { label: "Vw necessário", value: formatValue(vs?.vwRequired, 2), unit: "m³/h", ok: true },
        { label: "ΔP", value: formatValue(vs?.deltaPBar, 3), unit: "bar" },
        { label: "Válvula selecionada", value: `${vs?.quantity ?? "-"}x DN${vs?.dn ?? "?"}`, unit: "" },
        { label: "Capacidade por válvula", value: formatValue(vs?.capacityPerValve, 2), unit: "m³/h" },
        { label: "Capacidade total", value: formatValue(vs?.totalCapacity, 2), unit: "m³/h" },
    ];
};



